import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const FRAMES = {
  left: "/mascot/mascot-left.webp?v=3",
  right: "/mascot/mascot-right.webp?v=3",
};

export const MASCOT_INTERVAL = 2600;

export const Mascot = ({ className = "", testId = "mascot", frame: controlled }) => {
  const [internal, setInternal] = useState("left");
  const frame = controlled ?? internal;

  useEffect(() => {
    if (controlled) return;
    const t = setInterval(
      () => setInternal((f) => (f === "left" ? "right" : "left")),
      MASCOT_INTERVAL
    );
    return () => clearInterval(t);
  }, [controlled]);

  const rot = frame === "left" ? -3 : 3;

  return (
    <motion.div
      data-testid={testId}
      className={className}
      animate={{ rotate: rot, x: rot * 6 }}
      transition={{ type: "spring", stiffness: 80, damping: 12 }}
      style={{ transformOrigin: "50% 100%" }}
    >
      <div className="absolute inset-0 scale-100 lg:scale-[1.2] origin-top">
        {Object.entries(FRAMES).map(([key, src]) => (
          <img
            key={key}
            src={src}
            alt="TPECO leak detection mascot searching for your leak"
            draggable={false}
            className={`absolute inset-0 w-full h-full object-contain object-bottom pointer-events-none select-none transition-opacity duration-300 ${
              frame === key ? "opacity-100" : "opacity-0"
            }`}
          />
        ))}
      </div>
    </motion.div>
  );
};
